/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { GetStaticPropsContext } from 'next';
import { transformAreaData } from '@/utils/transformAreaData';
import { isEmpty, isUndefined, omitBy } from 'lodash';
import { useDispatch } from 'react-redux';
import { resetFilter } from '@/slices/filterFlight/filterFlightSlice';
import {
  addFallbackPoints, addHomePoints, clearHomePoints, clearPoints,
} from '@/slices/area/slices/searchFlightFormSlice';
import { resetSortingFlight } from '@/slices/sortingFlight/sortingFlightSlice';
import CompanyPageContainer, { AIRLINES } from '@/containers/CompanyPageVcms/desktop';
import { persistor } from '@/utils/store';
import { addGoyoloTemplateData, setTableContent, updateListAreas } from '@/slices/goyoloSeo/goyoloSeoSlice';
import { addMultipleFlightTrainConfig } from '@/slices/strapi/slices/strapiSlice';
import { getMultipleFlightTrainConfig } from '@/utils/getMultipleFlightTrainConfig';
// import { store } from '@/utils/store';
import { parseSeoLinkVcms } from '@/utils/parseSeoLinkVcms';
import { getFlexiData, queryAndTransformSeoTemplate, getAirports } from '@/utils/queryAndTransformSeoTemplate';
import { querySeoDistanceToDistrict, querySeoVrouteData, querySeoVrouteDataToday } from '@/utils/querySeoVrouteData';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';
import { SEO_PAGE_TYPE } from '@/utils/constants';
import { setSelectedDate } from '@/slices/calendar/calendarSlice';
import { useAppSelector } from '@/utils/hook';
import { storeWrapper } from '@/utils/store';
import { style } from '@/styles/globals';
import { getListAreas, getListTetPrice } from '@/utils/getListAreas';
import { format, isBefore } from 'date-fns';
import { GoyoloFlexiEntityResponse } from '@/slices/goyoloSeo/sliceType';
import { addImagesPromotion } from '@/slices/strapi/slices/strapiSlice';
import { captureException } from '@sentry/nextjs';
import { staticPaths } from '@/utils/staticPaths';

export const airlineMapping = {
  'vietnam-airlines': 'VN',
  'vietjet-air': 'VJ',
  'bamboo-airways': 'QH',
  'vietravel-airlines': 'VU',
  'pacific-airlines': 'BL',
};
let selectedCompany = '';
const RoutePage = ({
  startPoint, toPoint, countResult, countSeoResult, countSeoAllResult, countSeoReturnResult, company, flightResult, templateData, pageType, airport, time, countTetResult, listAreas, route,
  countSeoTetResult, tetData, imagePromotion, multipleFlightTrainConfig,
}: any) => {
  if (persistor) {
    persistor.pause();
  }
  const dispatch = useDispatch();
  const router = useRouter();

  const { query: { slug } } = router;
  Object.keys(airlineMapping).some((_company: string) => {
    if (slug?.includes(_company)) {
      selectedCompany = _company;
      return true;
    }
    return false;
  });

  useEffect(() => {
    setTimeout(() => {
      try {
        dispatch(addGoyoloTemplateData(templateData));
        if (listAreas) {
          dispatch(updateListAreas(listAreas));
        }
      } catch (err) {
        // console.warn('Redux dispatch error in templateData effect:', err);
      }
    });
  }, [templateData]);

  useEffect(() => {
    setTimeout(() => {
      try {
        if (multipleFlightTrainConfig && Object.keys(multipleFlightTrainConfig).length > 0) {
          dispatch(addMultipleFlightTrainConfig(multipleFlightTrainConfig));
        }
      } catch (err) {
        // console.warn('Redux dispatch error in templateData effect:', err);
      }
    });
  }, [multipleFlightTrainConfig]);
  useEffect(() => {
    setTimeout(() => {
      dispatch(addFallbackPoints());
      dispatch(resetFilter());
      dispatch(resetSortingFlight());
      dispatch(setSelectedDate({
        dateObj: JSON.stringify({
          depart: new Date().toString(),
          return: null,
        }),
      }));
      if (slug) {
        if ((!company && isEmpty(startPoint) && !isEmpty(toPoint))
    || (company && !isEmpty(toPoint) && isEmpty(startPoint))) {
          dispatch(clearPoints({ type: 'from' }));
          dispatch(clearHomePoints({ type: 'from' }));
        } else if (company && isEmpty(toPoint)) {
          dispatch(clearPoints({ type: 'all' }));
        } else if (airport) {
          dispatch(clearPoints({ type: 'all' }));
        }
      }
      if (!isEmpty(startPoint)) {
        dispatch(
          addHomePoints({
            type: 'from',
            data: startPoint,
          }),
        );
      }
      if (!isEmpty(toPoint)) {
        dispatch(
          addHomePoints({
            type: 'to',
            data: toPoint,
          }),
        );
      }
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      dispatch(addFallbackPoints());
      dispatch(resetFilter());
      dispatch(resetSortingFlight());
      dispatch(setSelectedDate({
        dateObj: JSON.stringify({
          depart: new Date().toString(),
          return: null,
        }),
      }));
      if (slug) {
        if ((!company && isEmpty(startPoint) && !isEmpty(toPoint))
    || (company && !isEmpty(toPoint) && isEmpty(startPoint))) {
          dispatch(clearPoints({ type: 'from' }));
          dispatch(clearHomePoints({ type: 'from' }));
        } else if (company && isEmpty(toPoint)) {
          dispatch(clearPoints({ type: 'all' }));
        } else if (airport) {
          dispatch(clearPoints({ type: 'all' }));
        }
      }
      if (!isEmpty(startPoint)) {
        dispatch(
          addHomePoints({
            type: 'from',
            data: startPoint,
          }),
        );
      }
      if (!isEmpty(toPoint)) {
        dispatch(
          addHomePoints({
            type: 'to',
            data: toPoint,
          }),
        );
      }
    });
    const textH3 = document.querySelectorAll('h3');
    textH3?.forEach((el) => {
      el.style.color = style.primary.blue;
    });
  }, []);
  // useEffect(() => {
  //   let ext = '';
  //   switch (pageType) {
  //     case SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE:
  //       ext = `from-${slugifyString(searchFlightForm?.startPointHome?.location)}-to-${slugifyString(searchFlightForm?.toPointHome?.location)}.${searchFlightForm?.toPointHome?.stateId}.${searchFlightForm?.startPointHome?.stateId}.en`;
  //       console.log('ext')
  //       break;
  //     default: break;
  //   }
  //   console.log(ext);
  // }, [searchFlightForm]);
  const isDesktop = !useCheckIsMobile(false);

  if (slug) {
    return (
      <CompanyPageContainer
        imagePromotion={imagePromotion}
        isDesktop={isDesktop}
        company={selectedCompany}
        startPoint={isEmpty(startPoint) ? null : startPoint}
        toPoint={toPoint}
        company2={company}
        countResult={countResult}
        countTetResult={countTetResult}
        countSeoTetResult={countSeoTetResult}
        countSeoResult={countSeoResult}
        countSeoAllResult={countSeoAllResult}
        countSeoReturnResult={countSeoReturnResult}
        flightResult={flightResult}
        pageType={pageType}
        templateDataObj={templateData}
        // route={route}
        tetData={tetData}
        route={route}
        airport={airport}
      />
    );
  }
  return <div />;
};

const hcmData = {
  full_name: 'Sài Gòn',
  name: 'Sài Gòn',
  name_token: 'Sài Gòn',
  state_name: 'Sài Gòn',
};
export const getStaticProps = storeWrapper.getStaticProps((store) => async (context: GetStaticPropsContext | any) => {
  let startPoint: any = {};
  let toPoint: any = {};
  const ES_BASE_URL = process.env.APP_ENV === 'production' ? (process.env.ELASTICSEARCH_HOST || 'https://es01.vexere.com') : 'https://uat-es-vxr-c01.vexere.net';
  const route = parseSeoLinkVcms((context?.params?.slug || '') as string);
  const templateFlexiData = await getFlexiData(route.type, route?.airport, route?.company, route);
  if (route.toAreaId === templateFlexiData?.formArea?.fromAreaId) {
    route.toAreaId = route.fromAreaId;
    route.toArea = route.fromArea;
  }
  if (route.airport) {
    route.fromAreaId = templateFlexiData?.formArea?.fromAreaId || null;
    route.fromArea = templateFlexiData?.formArea?.fromAreaId || null;
  }
  if (route.fromAreaId) {
    let from;
    try {
      const startPointRes = await fetch(`${ES_BASE_URL}/area/_doc/${route.fromAreaId}`);
      from = (await startPointRes.json())._source;
    } catch (err) { from = {}; }
    if (route.fromAreaId === 29) {
      from = {
        ...(from || {}),
        ...hcmData,
      };
    }
    startPoint = transformAreaData([from])[0];
  }
  if (route.toAreaId) {
    let to;
    try {
      const toPointRes = await fetch(`${ES_BASE_URL}/area/_doc/${route.toAreaId}`);
      to = (await toPointRes.json())._source;
    } catch (err) { to = {}; }
    toPoint = transformAreaData([to])[0];
    if (route.toAreaId === 29) {
      to = {
        ...(to || {}),
        ...hcmData,
      };
    }
  }
  const pageType = route.type;
  const lang = route.lang;
  const airportDeparture = [SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE, SEO_PAGE_TYPE.FROM_TO_PAGE].includes(pageType) ? await getAirports(startPoint, 'departure', route.lang) : null;
  const airportArrival = [SEO_PAGE_TYPE.AIRLINE_TO_PAGE, SEO_PAGE_TYPE.TO_PAGE, SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE, SEO_PAGE_TYPE.FROM_TO_PAGE].includes(pageType) ? await getAirports(toPoint, 'arrival', route.lang) : null;
  const fromAirportCode = (startPoint?.airports || [])?.map((airport: { airportCode: any; }) => airport?.airportCode);
  const toAirportCode = (toPoint?.airports || [])?.map((airport: { airportCode: any; }) => airport?.airportCode);
  const filterAirlines = route.company && AIRLINES[route.company] ? [AIRLINES[route.company].type] : [];
  const {
    countResult, countSeoAllResult, countSeoResult, countSeoReturnResult, countTetResult,
    countSeoTetResult,
  } = await querySeoVrouteData({
    fromCode: [SEO_PAGE_TYPE.AIRLINE_TO_PAGE, SEO_PAGE_TYPE.TO_PAGE].includes(pageType) ? '' : fromAirportCode,
    toCode: toAirportCode,
    airlines: filterAirlines,
    route,
  });
  let cheapestTripAirport = null;
  if (route.airport) {
    const key = templateFlexiData?.airport?.code;
    cheapestTripAirport = await querySeoVrouteDataToday({
      route,
      fromCode: fromAirportCode,
      key,
    }) || null;
    const distanceToDistrict = await querySeoDistanceToDistrict({
      airportTemp: templateFlexiData?.airport,
      startPoint,
      lang: templateFlexiData?.templateData?.lang || null,
    });
    if (templateFlexiData.airport) {
      templateFlexiData.airport.distanceToDistrict = distanceToDistrict || '';
    }
  }
  const templateData = await queryAndTransformSeoTemplate({
    templateData: templateFlexiData?.templateData,
    startPoint,
    toPoint,
    route,
    pageType: route.type,
    countResult,
    countSeoResult,
    countTetResult,
    countSeoTetResult,
    countSeoReturnResult,
    countSeoAllResult,
    cheapestTripAirport,
    airport: templateFlexiData?.airport || null,
    airportArrival,
    airportDeparture,
    asPath: context?.params?.slug || '',
  });
  // Convert Date objects to strings for serialization
  if (templateData && templateData.calculatedParams && templateData.calculatedParams.days) {
    templateData.calculatedParams.days = templateData.calculatedParams.days.map((day: any) => ({
      ...day,
      date: day.date instanceof Date ? day.date.toISOString() : day.date, // Convert Date to ISO string
    }));
  }

  if (
    templateData
    && templateData.calculatedParams
    && templateData.calculatedParams.airlineNameList
  ) {
    templateData.calculatedParams.airlineNameList = templateData.calculatedParams.airlineNameList.filter(
      (item: any) => item !== undefined,
    );
  }
  if (templateData && !isEmpty(templateData)) {
    store.dispatch(addGoyoloTemplateData(templateData));
  }
  if (!isEmpty(startPoint)) {
    store.dispatch(
      addHomePoints({
        type: 'from',
        data: startPoint as any,
      }),
    );
  }
  if (!isEmpty(toPoint) && SEO_PAGE_TYPE.AIRPORT_PAGE !== route.type) {
    store.dispatch(
      addHomePoints({
        type: 'to',
        data: toPoint as any,
      }),
    );
  }
  let listAreas = null;
  let tetData = '';
  if (SEO_PAGE_TYPE.TET_PAGE === route.type) {
    listAreas = await getListAreas();
    const lunarNewYearAirfareByPolularRoute = await getListTetPrice(listAreas);
    const dateLunarNewYear = isBefore(new Date(), new Date('2025-02-05')) ? '2025-02-05' : format(new Date(), 'yyyy-MM-dd');
    const lunarNewYearAirfareByAirline = await getListTetPrice(listAreas, dateLunarNewYear);
    const dateNewYear = isBefore(new Date(), new Date('2024-12-31')) ? '2024-12-31' : format(new Date(), 'yyyy-MM-dd');
    const newYearAirfareByPolularRoute = await getListTetPrice(listAreas, dateNewYear);
    tetData = JSON.stringify({
      lunarNewYearAirfareByPolularRoute,
      lunarNewYearAirfareByAirline,
      newYearAirfareByPolularRoute,
    });
  }
  const goyoloSeoHeaders = {
    Authorization: `Bearer ${process.env.VCMS_TOKEN}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  let imagePromotion;
  try {
    const goyoloSeoFlexiData = `${process.env.VCMS_BASE_URL}/api/flexi-entities?filters[slug][$eq]=banner-discount&populate=deep`;
    const goyoloFlexiArray = await fetch(goyoloSeoFlexiData, { headers: goyoloSeoHeaders }).then((rps) => rps.json()).then((rps) => rps.data) as GoyoloFlexiEntityResponse[];
    imagePromotion = goyoloFlexiArray?.[0]?.attributes?.jsonAttributes?.[0]?.value;
  } catch (err) {
    captureException(err);
    console.error(err);
  }

  // Fetch multiple flight train config
  let multipleFlightTrainConfig = {};
  try {
    multipleFlightTrainConfig = await getMultipleFlightTrainConfig();
    if (Object.keys(multipleFlightTrainConfig).length > 0) {
      store.dispatch(addMultipleFlightTrainConfig(multipleFlightTrainConfig));
    }
  } catch (err) {
    captureException(err);
    console.error('Error fetching multiple flight train config:', err);
  }
  // Clean route object to ensure no undefined values
  const cleanRoute = Object.fromEntries(
    Object.entries(route).map(([key, value]) => [key, value === undefined ? null : value]),
  );

  const returnProp = omitBy({
    props: {
      startPoint: [SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE, SEO_PAGE_TYPE.FROM_TO_PAGE, SEO_PAGE_TYPE.AIRPORT_PAGE].includes(route.type) ? startPoint : null,
      toPoint: [SEO_PAGE_TYPE.AIRLINE_PAGE, SEO_PAGE_TYPE.AIRPORT_PAGE].includes(route.type) ? null : toPoint,
      countResult: countResult || null,
      countSeoResult: countSeoResult || null,
      countTetResult: countTetResult || null,
      countSeoTetResult: countSeoTetResult || null,
      countSeoAllResult: countSeoAllResult || null,
      countSeoReturnResult: countSeoReturnResult || null,
      flightResult: {},
      ...(!isEmpty(filterAirlines) && filterAirlines.length !== 4 ? { company: filterAirlines[0] } : {}),
      templateData,
      pageType,
      airport: route.airport || null,
      listAreas,
      route: cleanRoute,
      tetData,
      imagePromotion: imagePromotion || null,
      multipleFlightTrainConfig: multipleFlightTrainConfig || {},
      isSeo: true,
    },
  }, isUndefined) as any;
  // only ve-may-bay-tet using static content, other slug using dynamic vcms content
  if (context?.params?.slug !== 've-may-bay-tet') {
    returnProp.revalidate = 10;
  }
  return returnProp;
});

export const getStaticPaths = async () => {
  const isProd = process.env.APP_ENV === 'production';
  const isCanary = process.env.APP_ENV === 'canary';
  const isUat = !isProd && !isCanary;
  const cityToCityPathsProd = staticPaths.map((url: any) => ({
    params: { slug: url },
  }));
  const cityToCityPathsUat = [cityToCityPathsProd[0]];

  const paths = [
    { params: { slug: 've-may-bay-tet' } },
    // ...(isUat ? cityToCityPathsUat : cityToCityPathsProd),
  ];

  return {
    paths,
    fallback: 'blocking', // or 'blocking' or 'false'
  };
};

export default RoutePage;
